<template>
  <div class="wishlist-container">
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
    <ServerError v-if="ServerError" />
    
    <v-snackbar v-model="showSnackBar" color="#3EA56E" right :timeout="timeout" class="mt-12">
      <div class="d-flex align-center">
        <v-icon color="white" class="mr-2">mdi-heart</v-icon>
        <span class="font-weight-medium">{{ msg }}</span>
        <v-spacer></v-spacer>
        <v-btn icon small @click="showSnackBar = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <div class="d-flex align-center mb-8">
      <v-icon color="#3EA56E" class="mr-3">mdi-heart-outline</v-icon>
      <h2 class="section-title">My Wishlist</h2>
    </div>

    <v-layout wrap v-if="products && products.length > 0">
      <v-flex
        xs12
        sm6
        lg4
        xl3
        pa-2
        v-for="(item, i) in products"
        :key="i"
      >
        <WishlistItem
          v-bind:storage="item"
          v-bind:cardWidth="'100%'"
          @stepper="winStepper"
        />
      </v-flex>
    </v-layout>

    <div v-else-if="!appLoading" class="text-center py-12">
      <v-icon size="64" color="#e2e8f0" class="mb-4">mdi-heart-plus-outline</v-icon>
      <p class="empty-text">Your wishlist is empty.</p>
      <v-btn color="#3EA56E" dark depressed to="/Products" class="mt-4 px-8 text-none font-weight-bold rounded-lg">
        Explore Products
      </v-btn>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import WishlistItem from "./wishlistItem";
export default {
  components: {
    WishlistItem,
  },
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      products: [],
      ServerError: false,
    };
  },
  beforeMount() {
    this.setMetaTags();
    this.getData();
  },
  methods: {
    setMetaTags() {
      document.title = "My Wishlist | KL-06 FARM";
      let metaDescription = document.querySelector('meta[name="description"]');
      const description = "View and manage your saved favorite products at KL-06 FARM.";
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    getData() {
      this.appLoading = true;
      var headers1 = {};
      var data = {};
      
      if (this.$store.state.isLoggedIn) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        data["guestid"] = localStorage.getItem("guestId");
      }

      axios({
        method: "GET",
        url: "/WishList/all",
        headers: headers1,
        params: data,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.wishlist;
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.error("Error fetching wishlist:", err);
        });
    },
    winStepper(item) {
      if (item.ref == "remove") {
        this.msg = item.response.msg;
        this.showSnackBar = true;
        if (item.getData) {
          this.getData();
        }
      }
    },
  },
};
</script>

<style scoped>
.wishlist-container {
  text-align: left;
}

.section-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 20px;
  color: #1a202c;
  margin: 0;
}

.empty-text {
  font-family: "sofialight", sans-serif;
  font-size: 16px;
  color: #64748b;
  margin: 0;
}

@media (max-width: 600px) {
  .section-title {
    font-size: 18px;
  }
}
</style>